import { isMobile as isMobileLib, isTablet as isTabletLib, isIPad13 } from 'react-device-detect';

const forceTablet = new URLSearchParams( window.location.search ).has( 'forceTablet' );

export const isMobile = isMobileLib;
export const isTablet = forceTablet || isTabletLib || isIPad13;
